module.exports = __webpack_public_path__ + "static/media/bajajLogo.5295fc84.svg";